import { HttpClient, HttpParams } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Platform } from "@ionic/angular";
import { Navigator } from "src/app/services/routing/navigator";
import { ConfigService } from "../config/config.service";
import { EventsService } from "../event/event.service";
import { GameHubControllerService } from "../gameHub/game-hub-controller";
import { UserSessionService } from '../user-session/user-session.service';
import { WebservicesService } from '../webservices/webservices.service';
import { CustomerModel } from 'src/app/models/customer-model';
import { IonicSafeString, ToastController } from '@ionic/angular';
import { InAppReview } from '@capacitor-community/in-app-review';
import { App } from "@capacitor/app";
@Injectable({
  providedIn: "root",
})

export class AppRateService {
  public shouldSelectEnvironment: boolean = false;
  public shouldUpdate: boolean = false;
  public shouldRestrictPlayStore: boolean = false;
  public customer: CustomerModel;
  public isGaming: boolean = false;
  public firstTime: boolean = true;
  public isLoggedin: boolean = true;
  constructor(
    private platform: Platform,
    private webservices: WebservicesService,
    private userSession: UserSessionService,
    public config: ConfigService,
    public navigator: Navigator,
    public gameHubControllerService: GameHubControllerService,
  ) {
    this.userSession.getCustomer().subscribe(
      (customer) => {
        this.customer = customer;
      }
    )

   }

  runAndroidFlow(){
    this.sendFeedback("presented","presented","android");
    InAppReview.requestReview();

  }

  runIosFlow(e){
    this.navigator.openPopover(
      "PopoveApprateComponent",
      e,
      "standard-popover mobile-webview app-rate",
      false
    );
  }

  processAppRate(e){
    if(this.platform.is("ios")){
     this.runIosFlow(e);
    } else if(this.platform.is("android")) {
      this.runAndroidFlow();
    }
  }

  async sendFeedback(action: string, result: string, device: string, comment:string = "") {
    const info = this.platform.is("capacitor") ? await App.getInfo() : { "id": "com.mohegansun.casinoapp", "version": "1.0.99", "build": "1", "name": "Mohegan Sun Casino" }
    const appVersion: string = !!info.version ? info.version : "1.0.0";
    comment = new IonicSafeString(comment).value;
    let obj: any = {
      result: result,
      action: action,
      device : device,
      comment: comment,
      appversion: appVersion,
      customer_id: this.customer.customerId,
      session_token: this.userSession.getSessionToken()
    }
    return this.webservices.post('/customer/send-feedback', obj);
  }

}
